import GlBaseAnimatedIcon from './base_animated_icon';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

var script = {
  name: 'GlAnimatedTodoIcon',
  extends: GlBaseAnimatedIcon
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.iconStateClass, _vm.iconVariantClass],attrs:{"aria-label":_vm.ariaLabel,"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{staticClass:"gl-animated-todo-box",attrs:{"d":"M14.25 6.75L14.25 13C14.25 13.6904 13.6904 14.25 13 14.25L3 14.25C2.30964 14.25 1.75 13.6904 1.75 13L1.75 3C1.75 2.30964 2.30964 1.75 3 1.75L13.25 1.75","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_vm._v(" "),_c('path',{staticClass:"gl-animated-todo-plus-line",attrs:{"d":"M10.75 3L15.25 3","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_vm._v(" "),_c('path',{staticClass:"gl-animated-todo-plus-line",attrs:{"d":"M13 5.25L13 0.75","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_vm._v(" "),_c('path',{staticClass:"gl-animated-todo-check",attrs:{"d":"M6.75 7.76299L9.15312 10.2469L15.25 4.15","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__ as default };
